import { Module } from "@webmotors/ioc";
import { LoggerModule } from "../logger";
import { WebSocketService } from "./websocket.service";

export const WebSocketModule: Module = {
  name: "WebSocketModule",
  modules: [LoggerModule],
  providers: [WebSocketService],
};